// extracted by mini-css-extract-plugin
export var dividerLine = "_a1-3";
export var itemImage = "_a1-9";
export var lightDivider = "_a1-4";
export var modalContent = "_a1-5";
export var modalContentCompact = "_a1-6";
export var productCard = "_a1-a";
export var productImage = "_a1-b";
export var productImageCompact = "_a1-7";
export var productImagePlaceholder = "_a1-c";
export var productImagePlaceholderCompact = "_a1-8";
export var progressBarBackground = "_a1-1";
export var progressBarContainer = "_a1-0";
export var progressBarFill = "_a1-2";